import React, { Component } from 'react';
import { messageVolumeCoverageIsLoadingSelector, messageVolumeCoverageVisSelector } from '../../selectors/message-volume-coverage-selectors';

import PropTypes from 'prop-types';
import StreamDotPlotChart from '../../../common/components/charts/stream-dot-plot-chart';
import { connect } from 'react-redux';
import { selectedIntervalSelector } from '../../selectors/reports-selectors';

export class MessageVolumeVisContainer extends Component{
    constructor( props ){
        super( props );

        this.state = {
            height: 250,
            margin: {
                bottom: 48,
                left: 0,
                right: 8,
                top: 8,
            },
            width: 800
        };
    }

    render(){
        let { isLoading, selectedInterval, data } = this.props;
        const { height, margin, width } = this.state;

        const options = { height, margin, width };
        const dotPlotOptions = {
            key: 'percentCoveredByPolicy',
        };

        const streamOptions = {
            keys: ['total'],
        };

        return (
            <StreamDotPlotChart
                data={data}
                xKey="date"
                dotPlotOptions={dotPlotOptions}
                streamOptions={streamOptions}
                interval={selectedInterval}
                isLoading={isLoading}
                options={options}

            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        data: messageVolumeCoverageVisSelector( state ),
        isLoading: messageVolumeCoverageIsLoadingSelector( state ),
        selectedInterval: selectedIntervalSelector( state ),
    };
};

MessageVolumeVisContainer.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    selectedInterval: PropTypes.string,
};

export default connect( mapStateToProps )( MessageVolumeVisContainer );
